<template>
    <validation-observer ref="template_settings_form" v-slot="{ meta, errors, setFieldValue }">
        <modal
            :id="modalId"
            :title="title"
            @ok.prevent="editPropertyTemplateSettings"
            @hidden="clearValues"
            @shown="setData"
        >
            <busy-modal :show="loading" />
            <div v-if="values">
                <b-row>
                    <b-col md="6" class="pr-md-0">
                        <validation-provider name="daily_rate" rules="validFloat|required">
                            <form-input
                                v-model="values.daily_rate"
                                :error="errors.daily_rate"
                                label="Nightly Rate Delta:"
                                placeholder="0.00"
                                @change="(val) => setFieldValue('daily_rate', val)"
                            />
                        </validation-provider>
                    </b-col>
                    <b-col md="6">
                        <validation-provider name="weekend_rate" rules="validFloat|required">
                            <form-input
                                v-model="values.weekend_rate"
                                :error="errors.weekend_rate"
                                label="Weekend Rate Delta:"
                                placeholder="0.00"
                                @change="(val) => setFieldValue('weekend_rate', val)"
                            />
                        </validation-provider>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="6" class="pr-md-0">
                        <validation-provider name="weekly_rate" rules="validFloat|required">
                            <form-input
                                v-model="values.weekly_rate"
                                :error="errors.weekly_rate"
                                label="Weekly Rate Delta:"
                                placeholder="0.00"
                                @change="(val) => setFieldValue('weekly_rate', val)"
                            />
                        </validation-provider>
                    </b-col>
                    <b-col md="6">
                        <validation-provider name="monthly_rate" rules="validFloat|required">
                            <form-input
                                v-model="values.monthly_rate"
                                :error="errors.monthly_rate"
                                label="Monthly Rate Delta:"
                                placeholder="0.00"
                                @change="(val) => setFieldValue('monthly_rate', val)"
                            />
                        </validation-provider>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="12">
                        <b-form-select
                            v-model="values.seasonality_template_selected"
                            :options="options"
                            text-field="name"
                            value-field="id"
                            label="Seasonality Template:"
                        ></b-form-select>
                    </b-col>
                </b-row>
                <p class="font-weight-bold text-danger form-warning mt-2">
                    Warning: Changing any of this values will modify all existing rates for this property.
                </p>
            </div>
            <!-- <template #modal-footer="{ cancel, ok }"> -->
            <template #modal-footer="{ cancel }">
                <b-button variant="primary" @click="editPropertyTemplateSettings">Save</b-button>
                <b-button variant="warning" @click="cancel()">Cancel</b-button>
            </template>
        </modal>
    </validation-observer>
</template>

<script>
    import Modal from '../../generic/modal/modal.vue';
    import BusyModal from '../../generic/busy-modal/busy-modal.vue';
    import FormInput from '../../generic/form-input/form-input.vue';
    import FormCheckbox from '../../generic/form-checkbox/form-checkbox.vue';
    import FormDatepicker from '../../generic/form-datepicker/form-datepicker.vue';
    import FormSelect from '../../generic/form-select/form-select.vue';
    import { templatesMixin } from '../mixins/templates-mixin';

    export default {
        components: {
            Modal,
            BusyModal,
            FormInput,
            FormDatepicker,
            FormCheckbox,
            FormSelect,
        },
        mixins: [templatesMixin],
        data() {
            return {
                values: null,
                renderComponent: true,
            };
        },
        props: {
            modalId: String,
            title: String,
            initValues: Object,
            loading: Boolean,
        },
        computed: {
            options() {
                const notSet = { id: -1, name: 'Not set' };
                const templateOptions = this.templates;
                return [notSet, ...templateOptions];
            },
        },
        methods: {
            clearValues() {
                this.values = null;
            },
            async editPropertyTemplateSettings() {
                const meta = await this.$refs.template_settings_form.validate();
                if (meta.valid) {
                    this.$emit('submit', this.values);
                }
            },
            setData() {
                this.$refs.template_settings_form.setValues({
                    daily_rate: this.values.daily_rate,
                    weekend_rate: this.values.weekend_rate,
                    weekly_rate: this.values.weekly_rate,
                    monthly_rate: this.values.monthly_rate,
                });
            },
        },
        watch: {
            initValues() {
                this.values = this.initValues;
            },
        },
    };
</script>

<style lang="scss" scoped>
    :deep(.modal-dialog) {
        max-width: 665px !important;
    }

    :deep(.form-warning) {
        font-size: 12px !important;
    }
</style>
